export class EdContextMenuOptionsModel {
  
  public id: any;
  public type: any;
  public text :string;
  public icon :string;
  public borderBottom :boolean;
  public disabled :boolean;
  public discartAction :boolean;
  public path?: string;
  public code: string;
  public color: string;
  public router?: boolean;
  public route?: string;

  constructor({id = null, text = '', type = '', icon = null, borderBottom = false, disabled = false, discartAction = false, path = '', code = '', color = '', router = false, route = ''}: any) {
    this.id = id;
    this.type = type;
    this.text = text;
    this.icon = icon;
    this.borderBottom = borderBottom;
    this.disabled = disabled;
    this.discartAction = discartAction;
    this.path = path;
    this.code = code;
    this.color = color;
    this.router = router;
    this.route = route;
  }

}